import React from 'react'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PauseOutlined from "@mui/icons-material/PauseOutlined";
import BackHandOutlined from "@mui/icons-material/BackHandOutlined";

function TimeClockShiftCard(props) {
  const { shift, location, status } = props;

  // Use the formatted shift times from add_shift_attributes
  const startTime = {
    number: shift?.shift_start_formatted?.[0] || "",
    letters: shift?.shift_start_formatted?.[1] || ""
  };

  const endTime = {
    number: shift?.shift_end_formatted?.[0] || "",
    letters: shift?.shift_end_formatted?.[1] || ""
  };

  // Use the formatted break text from add_shift_attributes
  const breakText = shift?.break_formatted || "No meal break";

  // Use the paid break summary from add_shift_attributes
  const paidBreaksSummary = shift?.paid_break_summary;

  return (
    <div className="relative w-[275px] bg-violet-50 rounded-2xl px-5 py-4">
      <div className="flex flex-row items-center">
        <p className="text-slate-900 text-[22px] font-bold">
          {startTime.number}
        </p>
        <p className="text-slate-600 text-lg ml-1">
          {startTime.letters}
        </p>
        <div className="ml-2">
          <ArrowForwardIcon sx={{ color: "#475569", fontSize: 22 }} />
        </div>
        <p className="text-slate-900 text-[22px] font-bold ml-2">
          {endTime.number}
        </p>
        <p className="text-slate-600 text-lg ml-1">
          {endTime.letters}
        </p>
      </div>
      <div className="mt-1.5">
        <p className="text-slate-600 text-[16px]">
          {shift?.station?.name || shift?.role || shift?.roleType}
          {location && ` @ ${location}`}
        </p>
        <div className="mt-2.5 flex flex-row items-center">
          <PauseOutlined sx={{ color: "#475569", fontSize: 16 }} />
          <p className="text-slate-600 ml-1 text-xs">{breakText}</p>
        </div>
        {paidBreaksSummary && (
          <div className="mt-1.5 flex flex-row items-center pr-20">
            <BackHandOutlined sx={{ color: "#475569", fontSize: 16 }} />
            <p className="text-slate-600 ml-1 text-xs">{paidBreaksSummary}</p>
          </div>
        )}
      </div>
      <div className="absolute bottom-3.5 right-3.5">
        <div className="bg-violet-100 px-3 py-1 rounded-full">
          <p className="text-violet-600 text-xs">
            {status === "Active" ? "In Progress" : "Awaiting"}
          </p>
        </div>
      </div>
    </div>
  )
}

export default TimeClockShiftCard
